import useDialogModal from 'hooks/use-dialog-modal';
import { routes } from 'utils/routing';

interface IUseOfferUnavailableModalProps {
  onCancelRedemption(): void;
  navigate: (to: string) => void;
}

export default function useOfferUnavailableModal({
  onCancelRedemption,
  navigate,
}: IUseOfferUnavailableModalProps) {
  // @ts-ignore FIXME: Expression produces a union type that is too complex to represent.ts(2590)
  return useDialogModal({
    showCancel: true,
    allowDismiss: false,
    onConfirm: () => {
      onCancelRedemption();
    },
    onCancel: () => {
      onCancelRedemption();
      navigate(routes.base);
    },
    modalAppearanceEventMessage: 'Cancel Redemption: Offer unavailable',
  });
}
